/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 11/08/2026
 * @update 11/08/2026
 */

import { Column } from "devextreme-react/data-grid";
import { Checkbox, Col, DatePicker, Row, TextInput, Dropdown, Typography, NumberInput, ButtonIcon, Tooltip } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W05F2030Actions from "../../../actions/w05/w05F2030/w05F2030-actions";
import Config from "../../../config";
import MForm from "../../common/form/form";
import GridContainer from "../../common/grid-container/grid-container";
import W2W from "../../common/w2w/index";
import { makeStyles, useTheme } from "diginet-core-ui/theme";
import GridActionBar from "../../common/action-bar/grid-action-bar-hover";

const useStyles = makeStyles(({ spacing, colors }) => {
    return {
        moneyInputColumn: {
            width: '100%',
            '& input': {
                textAlign: 'right'
            }
        },
    }
});
const FormID = 'W05F2030';
const initialDataMaster = {
    PolicyID: "",
    PolicyName: "",
    StatusID: "",
    StatusName: "",
    DateFrom: null,
    DateTo: null,
    UserGroupID: "",
    UserGroupName: "",
};
const requiredArr = ["PolicyID", "StatusID", "DateFrom"];
const arrRequiredColumn = ['SaleGroupID'];
const defaultDataRow = [{
    SaleGroupID: "",
    SaleGroupName: "",
    GroupTypeID: "",
    GroupTypeName: "",
    GroupInvID: "",
    GroupInvName: "",
    MethodID: "",
    MethodName: "",
    CommissionValue: null,
}];
const initialMode = "view";
const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

const W05F2030 = (props) => {
    const classes = useStyles();
    const { colors } = useTheme();
    const [mode, _setMode] = useState(initialMode); // Mặc định mode View
    const [isChangeForm, setIsChangeForm] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [isWarningSave, setIsWarningSave] = useState(false);
    const [loading, setLoading] = useState({});
    const [error, setError] = useState({});
    const [dataMaster, setDataMaster] = useState({ ...initialDataMaster });
    const [dataGridRight, setDataGridRight] = useState([{ ...defaultDataRow[0] }]);
    const [dataCbo, setDataCbo] = useState({});
    const [dataCboStatus, setDataCboStatus] = useState([]);
    const [dataCboUserGroup, setDataCboUserGroup] = useState([]);

    //===================useRef====================
    const w2wRef = useRef(null);
    const gridRightRef = useRef(null);
    const rowRef = useRef(null);
    const oldDataMaster = useRef(null);
    const oldDataGrid = useRef([]);
    const modeRef = useRef(initialMode);
    const modeOld = usePrevious(mode) || initialMode;
    const readOnly = modeRef.current === 'view';

    useEffect(() => {
        if (modeRef.current === "add") onNext(); // Thêm mới or nhập tiếp
        else if (modeOld === "view" && modeRef.current === "edit") handleEvaluationLevelGrid(dataGridRight); // Tại Chính Row đó Từ View Bấm Edit(Không có load Form) thì xử lý lưới
        else loadForm("loadForm");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modeRef.current]);

    useEffect(() => {
        loadDataGeneral('LoadcmdObject');
        loadDataGeneral('LoadcmbMethod');
        loadDataGeneral('LoadcmbStatus');
        loadDataGeneral('LoadGroupUser');
        loadDataGeneral('LoadcmbPGroup');
        loadDataGeneral('LoadcmbItem');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setModeLoading = (modeLoad, value) => {
        if (modeLoad === 'LoadcmbItem') return;
        setLoading(prev => ({
            ...prev,
            [modeLoad]: value,
        }));
    };

    const loadDataGeneral = (modeLoad, paramPlus, cb) => {
        const params = gridParam(modeLoad, paramPlus);
        setModeLoading(modeLoad, true);
        props.W05F2030Actions.loadCbo(params, (err, data) => {
            setModeLoading(modeLoad, false);
            if (cb) return cb(err, data);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                gridParam(modeLoad, data);
            }
        });
    };

    const loadForm = (modeLoad, dataRow) => {
        setFormLoading(true);
        props.W05F2030Actions.loadForm(gridParam(modeLoad, dataRow), (err, data) => {
            setFormLoading(false);
            if (err) {
                oldDataMaster.current = initialDataMaster;
                oldDataGrid.current = [];
                setDataMaster(initialDataMaster);
                setDataGridRight([{ ...defaultDataRow[0] }])
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                gridParam(modeLoad, data);

            }
        });
    };

    const getModeParam = (dataTypeID) => {
        let result = dataTypeID === "LoadForm_2" ? 1 : 0;
        switch (modeRef.current) {
            case 'edit':
            case 'view':
                result = 1;
                break;
            case 'copy':
                result = 2;
                break;
            default:
                break;
        }
        return result;
    };

    const gridParam = (type, data) => {
        const dataRow = data || rowRef.current;
        let DataTypeID = '';
        const result = {
            Mode: 0,
            StrSearch: '',
            PolicyID: "",
            StrValue: ""
        };
        switch (type) {
            case 'loadGrid':
                DataTypeID = 'LoadForm_1';
                break;
            case 'loadForm':
                const { master = {}, detail = [] } = data || {};
                DataTypeID = 'LoadForm_2';
                result.Mode = getModeParam('LoadForm_2');
                result.PolicyID = dataRow?.PolicyID;
                setDataMaster({ ...initialDataMaster, ...master });
                oldDataMaster.current = { ...master };
                const newDetail = detail.map(item => ({
                    ...item
                }));
                oldDataGrid.current = newDetail.map(item => ({
                    ...item
                }));
                if (modeRef.current === 'edit' || modeRef.current === "copy") {
                    newDetail.push({
                        ...defaultDataRow[0]
                    });
                }
                setDataGridRight(newDetail);

                break;
            case 'isUsed':
                DataTypeID = 'Disabled';
                break;
            case 'LoadcmbItem':
                DataTypeID = 'LoadcmbItem';
                result.StrValue = data?.GroupTypeID || '';
                break;
            case 'LoadcmbPGroup':
                DataTypeID = 'LoadcmbPGroup';
                break;
            case 'LoadGroupUser':
                DataTypeID = 'LoadGroupUser';
                setDataCboUserGroup(data || [])
                break;
            case 'LoadcmbStatus':
                DataTypeID = 'LoadcmbStatus';
                data = (data || []).map(item => ({
                    ...item,
                    StatusID: String(item?.StatusID)
                }));
                setDataCboStatus(data || [])
                break;
            case 'LoadcmbMethod':
                DataTypeID = 'LoadcmbMethod';
                break;
            case 'LoadcmdObject':
                DataTypeID = 'LoadcmdObject';
                break;
            case 'delete':
                DataTypeID = 'Delete';
                break;
            case 'save':
                DataTypeID = 'Save';
                result.PolicyID = dataMaster?.PolicyID;
                result.Mode = getModeParam('Save');
                break;
            case 'approval':
                DataTypeID = 'Approved';
                result.PolicyID = dataRow?.PolicyID;
                break;
            case 'unApproval':
                DataTypeID = 'UnApproved';
                result.PolicyID = dataRow?.PolicyID;
                break;
            default:
                break;
        }
        result.DataTypeID = DataTypeID;
        if (["LoadcmdObject", "LoadcmbPGroup", "LoadcmbMethod"].includes(DataTypeID) && Array.isArray(data)) {
            setDataCbo(prev => {
                return {
                    ...prev,
                    [DataTypeID]: data
                };
            });
        }
        return result
    };

    const setDataMasterState = (obj = {}) => {
        setDataMaster({ ...dataMaster, ...obj });
    };

    const handleEvaluationLevelGrid = (dataGridRight) => {
        const dataGridInit = dataGridRight.map(item => ({ ...item }));
        let dataGridMode = dataGridRight;
        if (modeRef.current !== "view") {
            dataGridMode = [...dataGridMode,
            { ...defaultDataRow[0] }
            ];
        }
        oldDataGrid.current = dataGridInit.map(item => ({ ...item }));
        setDataGridRight(dataGridMode);
    };

    const onChangeRow = (data = {}) => {
        if (!Config.isEmpty(data)) {
            rowRef.current = data;
            loadForm('loadForm', data)
        }
        setError({});
        setIsChangeForm(false);
    };

    const onNext = (setModeAdd = false) => { // Clear Form
        if (setModeAdd) setMode('add');
        setError({});
        setIsChangeForm(false);
        oldDataGrid.current = [];
        oldDataMaster.current = initialDataMaster;
        setDataMaster({ ...initialDataMaster }); // set lại default
        setDataGridRight([{ ...defaultDataRow[0] }])
    };

    const renderIsDisabledColumn = (e) => {
        const value = e?.data?.Disabled ?? 0;
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'flex valign-middle'}
            checked={!!value}
        />;
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            return {
                name: item,
                rules: ['isRequired'],
                value: dataMaster[item]
            }
        });
    };

    const onSave = async () => {
        const resultValidate = checkValidateMaster(requiredArr);
        const validateForm = MForm.formValidation(resultValidate);
        let dataSource = dataGridRight;
        let isSomeEmptyCol = false;
        if (Object.keys(validateForm).length > 0) {
            setError(validateForm);
            return false;
        }
        else if (gridRightRef.current) {
            await gridRightRef.current.instance.saveEditData();
            dataSource = gridRightRef.current.instance.option('dataSource');
        }
        const allCol = Object.keys(defaultDataRow[0]);
        isSomeEmptyCol = dataSource.some((item, index) => (index + 1 === dataSource.length) && (dataSource.length !== 1) ? allCol.some(name => item[name] !== defaultDataRow[0][name]) : arrRequiredColumn.some(name => Config.isEmpty(item[name])));
        if (isSomeEmptyCol) {
            setIsWarningSave(true);
            Config.popupCore.show('INFO', Config.lang('Vui_long_nhap_day_du_thong_tin_tren_luoi'));
            return;
        }
        const params = {
            ...gridParam('save'),
            ...dataMaster,
            StatusID: Number(dataMaster?.StatusID) ?? null,
            data: dataGridRight.slice(0, -1) // tru dong add cuoi cua luoi
        };

        return {
            params,
            mode: modeRef.current,
            cb: isContinue => {
                setIsChangeForm(false);
                if (isContinue) onNext(true);
                else {
                    oldDataMaster.current = dataMaster;
                    oldDataGrid.current = dataGridRight;
                    setDataGridRight(dataGridRight);
                }
            }
        };
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.typeOf(value, 'boolean')) value = +value;
        if (['DateTo', 'DateFrom'].includes(fieldName) && Config.isEmpty(value)) value = null;
        let obj = { [fieldName]: value };
        switch (fieldName) {
            case "StatusID":
                obj = { ...obj, StatusID: String(value) || "", StatusName: e?.data?.StatusName || "", StatusColor: e?.data?.StatusColor || "" }
                break;
            default:
                obj = { [fieldName]: value }
                break;
        }

        setIsChangeForm(true);
        setDataMasterState(obj);
        if (error[fieldName] && value) setError({ ...error, [fieldName]: '' });
    };


    const renderDropdown = (e, modeLoad) => {
        let props = {};
        let objPlus = {};
        const { dataField } = e?.column || {};
        const dataSource = dataCbo[modeLoad] || [];
        let displayName = dataField;
        if (dataField.includes('ID')) displayName = dataField.replace('ID', 'Name');
        let displayExpr = displayName;

        const selectedItem = dataSource.find(
            item => item?.[dataField] === e?.value
        );

        const valueObjectDefault = !Config.isEmpty(e?.value)
            ? {
                [dataField]: e.value,
                [displayName]: e?.data?.[displayName] || selectedItem?.[displayName] || '',
            }
            : null;
        switch (dataField) {
            case 'GroupInvID':
                props = {
                    action: {
                        loadData: (params, cb) => loadDataGeneral('LoadcmbItem', e?.data, cb)
                    }
                };
                break;
            default:
                break;
        }
        return <Dropdown
            valueExpr={dataField}
            readOnly={mode === 'view'}
            displayExpr={displayExpr}
            loading={loading.modeLoad}
            viewType={'none'}
            value={e.value}
            valueObjectDefault={valueObjectDefault}
            onChange={(c) => {
                const value = c?.value;
                const name = c?.data?.[displayName];
                const oldValue = e?.value;
                e.component.cellValue(e.rowIndex, dataField, value);
                e.component.cellValue(e.rowIndex, displayName, name);
                if (dataField === 'GroupTypeID' && oldValue !== value) {
                    e.component.cellValue(e.rowIndex, 'GroupInvID', "");
                    e.component.cellValue(e.rowIndex, 'GroupInvName', "");
                }
                if (dataField === 'MethodID') {
                    e.component.cellValue(e.rowIndex, 'CommissionValue', null);
                }
                e.component.saveEditData();
            }}
            {...objPlus}
            {...(props?.action ? { action: props.action } : { dataSource })}
            {...props}
        />
    };



    const renderNumberFormat = (e, mode = 'view') => {
        if (!e) return false;
        const { column: { dataField = "" }, row: { data = {} } } = e || {};
        let decimalValue = e?.value ?? null;
        if (!Config.isEmpty(decimalValue) && Config.typeOf(decimalValue, 'string')) decimalValue = Number(decimalValue ?? null);
        let min;
        let max;
        if (dataField === "CommissionValue") {
            if (data?.MethodID === "Rate") {
                min = 0;
                max = 100;
            } else if (data?.MethodID === "Amount") {
                min = 1;
            }
        }
        const inputProps = {
            min,
            max,
            nonStyle: true,
            maxDigit: 28,
            decimalDigit: 8,
            thousandSeparator: ',',
            readOnly: mode !== 'edit',
            value: decimalValue,
            className: classes.moneyInputColumn,
        };

        if (mode === 'edit') {
            inputProps.onChange = (c) => {
                let value = c?.value ?? null;
                if (value !== null && value !== '') {
                    value = Number(value);
                    if (Number.isNaN(value)) value = null;
                }
                if (dataField === "CommissionValue" && value !== null) {
                    if (data?.MethodID === "Rate") {
                        value = Math.min(Math.max(value, 0), 100);
                    } else if (data?.MethodID === "Amount") {
                        value = Math.max(value, 1);
                    }
                }
                e.component.cellValue(e.rowIndex, dataField, value);
                e.component.saveEditData();
            };
        }

        return <NumberInput {...inputProps} />;
    };

    const handleAddNewRow = () => {
        gridRightRef.current.instance.saveEditData();
        const dataSource = gridRightRef.current.instance.option('dataSource');
        setDataGridRight([...dataSource, { ...defaultDataRow[0] }]);
    };

    const handleDeleteRow = (e) => {
        if (!e) return;
        e.component.deleteRow(e.rowIndex);
        if (gridRightRef.current) gridRightRef.current.instance.refresh();
        let dataSource = gridRightRef.current.instance.option('dataSource');
        dataSource = dataSource.map((item) => ({ ...item }));
        setIsChangeForm(true);
        setDataGridRight(dataSource);
        Config.notify.show('success', Config.lang('Xoa_thanh_cong'), 2000);
    };

    const renderBtnAction = (e) => {
        if (!e) return null;
        const { rowIndex } = e || {};
        const isLastRow = rowIndex + 1 === dataGridRight.length;
        return (
            <GridActionBar>
                <Tooltip title={Config.lang('Xoa')}>
                    <ButtonIcon
                        circular
                        viewBox
                        viewType={'text'}
                        name={'Delete'}
                        disabled={isLastRow || readOnly}
                        onClick={() => {
                            Config.popupCore.show('YES_NO', Config.lang(`Ban_co_chac_muon_xoa?`), () => {
                                handleDeleteRow(e);
                            });
                        }}
                    />
                </Tooltip>
            </GridActionBar>
        );
    };

    const renderGridRight = useMemo(() => {
        return (
            <GridContainer
                reference={ref => (gridRightRef.current = ref)}
                dataSource={dataGridRight}
                typePaging={'normal'}
                itemPerPage={30}
                elementAttr={{ style: 'min-height: 420px' }}
                listPerPage={[30, 60, 90, 120]}
                filterRow={{
                    visible: true,
                    showOperationChooser: false,
                    applyFilter: 'auto'
                }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: !readOnly,
                    texts: { confirmDeleteMessage: '' },
                    startEditAction: 'click',
                }}
                onRowValidating={(e) => {
                    if (!Config.isEmpty(Object.values(e?.newData)?.[0])) e.isValid = true;
                }}
                onRowUpdated={(e) => {
                    const { data } = e || {};
                    setIsChangeForm(true);
                    const isLastRow = Object.keys(data).every(name => data[name] === dataGridRight[dataGridRight.length - 1][name]);
                    if (isLastRow) { // Dong cuoi cung
                        const isAddRow = arrRequiredColumn.every(name => !Config.isEmpty(data?.[name]));
                        if (isAddRow) {
                            setTimeout(() => {
                                handleAddNewRow()
                            }, 900)
                        };
                    }
                }}
                onCellPrepared={(e) => {
                    const { cellElement, column, data, value, rowIndex, rowType } = e || {};
                    if (cellElement && isWarningSave && arrRequiredColumn.includes(column?.dataField) && Config.isEmpty(value)) {
                        let status = false;
                        if (rowIndex + 1 === dataGridRight.length) {
                            const allCol = Object.keys(defaultDataRow[0]);
                            const isDefaultRow = Object.keys(defaultDataRow[0]).every(
                                key => data[key] === defaultDataRow[0][key]
                            );
                            status = allCol.some(item => data[item] === defaultDataRow[0][item]) && (!isDefaultRow || dataGridRight.length === 1);
                        }
                        else status = true;
                        if (status && rowType !== "filter") cellElement.style.backgroundColor = colors.danger2;
                    }
                }}
            >
                <Column width={90} fixed allowSorting={false} cellRender={renderBtnAction} caption={Config.lang('Hanh_dong')} alignment={'center'} visible={Config.isMobile} />
                <Column
                    visible={false}
                    dataField={'SaleGroupName'}
                />
                <Column
                    width={280}
                    dataField={'SaleGroupID'}
                    caption={Config.lang('Nhom_doi_tuong')}
                    calculateDisplayValue={(rowData) => rowData?.SaleGroupName || ''}
                    editCellRender={(e) => renderDropdown(e, "LoadcmdObject")}
                />
                <Column
                    visible={false}
                    dataField={'GroupTypeName'}
                />
                <Column
                    width={180}
                    dataField={'GroupTypeID'}
                    caption={Config.lang('Loai_nhom_san_pham')}
                    calculateDisplayValue={(rowData) => rowData?.GroupTypeName || ''}
                    editCellRender={(e) => renderDropdown(e, "LoadcmbPGroup")}
                />
                <Column
                    visible={false}
                    dataField={'GroupInvName'}
                />
                <Column
                    width={220}
                    dataField={'GroupInvID'}
                    caption={Config.lang('Nhom_san_pham')}
                    calculateDisplayValue={(rowData) => rowData?.GroupInvName || ''}
                    editCellRender={(e) => renderDropdown(e, "LoadcmbItem")}

                />
                <Column
                    visible={false}
                    dataField={'MethodName'}
                />
                <Column
                    width={160}
                    dataField={'MethodID'}
                    caption={Config.lang('Phuong_thuc')}
                    calculateDisplayValue={(rowData) => rowData?.MethodName || ''}
                    editCellRender={(e) => renderDropdown(e, "LoadcmbMethod")}
                />
                <Column
                    width={160}
                    dataField={'CommissionValue'}
                    caption={Config.lang('Gia_tri_hoa_hong')}
                    editCellRender={(e) => renderNumberFormat(e, "edit")}
                />
                <Column allowEditing={false} width={50} fixed alignment={"right"} fixedPosition={"right"} visible={!Config.isMobile} cellRender={renderBtnAction} />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGridRight, readOnly, dataCbo.LoadcmdObject, dataCbo.LoadcmbItem, dataCbo.LoadcmbMethod, dataCbo.LoadcmbPGroup, isWarningSave, mode]);

    const handleLoadAction = (params, cb, paramMode) => {
        const actions = {
            delete: props.W05F2030Actions.onDelete,
            save: props.W05F2030Actions.onSave,
            loadGrid: props.W05F2030Actions.loadCbo,
            isUsed: props.W05F2030Actions.onDisable,
            approval: props.W05F2030Actions.loadApproval,
            unApproval: props.W05F2030Actions.loadApproval,
        };
        const action = actions[paramMode];
        if (!action) return;
        let payload = {
            ...gridParam(paramMode),
            ...params,
        };
        if (paramMode === 'save') {
            payload = {
                ...payload,
                ...dataMaster,
                StatusID: Number(dataMaster?.StatusID) ?? null,
                data: dataGridRight.slice(0, -1) // tru dong add cuoi cua luoi
            };
        }
        return action(payload, (err, data) => {
            if (err) {
                cb && cb(err, data);
                return;
            }
            if (data) {
                cb && cb(err, data);
                // Approval / UnApproval: sau khi API xong -> reload Form 2
                if ((paramMode === 'approval' || paramMode === 'unApproval') && data?.Status !== 1) {
                    const policyID = params?.PolicyID;
                    loadForm('loadForm', { PolicyID: policyID });
                }
            }
        }
        );
    };

    const setMode = (modeNe = initialMode) => {
        modeRef.current = modeNe;
        _setMode(modeRef.current);
    };

    return (
        <W2W
            ref={w2wRef}
            FormID={FormID} // FormID của màn hình để truyền vào params của các API phân quyền, Lưu lịch sử checkbox disabled, xóa
            isChanged={isChangeForm} // State quản lý dữ liệu cột bên phải đã thay đổi
            mode={mode}
            updateMode={(mode) => setMode(mode)}
            checkboxHidden
            action={{
                loadGrid: (params, cb) => handleLoadAction(params, cb, 'loadGrid'), // action load lưới trái
                add: (params, cb) => handleLoadAction(params, cb, 'save'), // action save thêm dòng mới
                edit: (params, cb) => handleLoadAction(params, cb, 'save'), // action save sửa dòng
                copy: (params, cb) => handleLoadAction(params, cb, 'save'), // action save sửa dòng
                delete: (params, cb) => handleLoadAction(params, cb, 'delete'), // action xóa dòng
                isUsed: (params, cb) => handleLoadAction(params, cb, 'isUsed'), // action sử dụng
                approval: (params, cb) => handleLoadAction(params, cb, 'approval'), // action duyệt
                unApproval: (params, cb) => handleLoadAction(params, cb, 'unApproval'), // action bỏ duyệt
            }}
            buttonProps={{
                edit: {
                    disabled: (e) => e?.data?.IsEdit === 1,
                },
                approval: {
                    disabled: (e) => e?.data?.IsApproval === 1,
                },
                unApproval: {
                    disabled: (e) => e?.data?.IsApproval === 0,
                },
            }}
            actionToolbar={{ // title của ActionToolbar 
                title: Config.lang('Danh_sach_chinh_sach_tinh_hoa_hong'),
            }}
            titleRight={Config.lang('Chi_tiet_chinh_sach_tinh_hoa_hong')}
            onSelectedRow={onChangeRow}
            keyExpr={'PolicyID'}
            onSave={onSave} // Xử lý sự kiện lưu
            loading={formLoading}
            leftCol={{ // Số cột hiển thị của lưới bên trái
                xs: 12,
                sm: 12,
                md: 5,
                lg: 5,
            }}
            dataColumnGrid={[ // Các cột của lưới trái 
                {
                    width: 200,
                    dataField: 'PolicyID',
                    caption: Config.lang('Ma_chinh_sach'),
                },
                {
                    width: 380,
                    dataField: 'PolicyName',
                    caption: Config.lang('Ten_chinh_sach')
                },
                {
                    width: 120,
                    dataType: 'boolean',
                    dataField: 'Disabled',
                    caption: Config.lang('Khong_su_dung'),
                    trueText: Config.lang('Co'),
                    falseText: Config.lang('Khong'),
                    cellRender: renderIsDisabledColumn,
                    calculateCellValue: (rowData) => !!rowData?.Disabled
                }
            ]}>
            {/* Cột bên phải */}
            <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <TextInput
                        required
                        readOnly={readOnly}
                        disabled={mode === 'edit'}
                        label={Config.lang('Ma_chinh_sach')}
                        value={dataMaster?.PolicyID}
                        error={error && error['PolicyID']}
                        onChange={e => onChange('PolicyID', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <TextInput
                        readOnly={readOnly}
                        label={Config.lang('Ten_chinh_sach')}
                        value={dataMaster?.PolicyName}
                        onChange={e => onChange('PolicyName', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <Dropdown
                        required
                        clearAble
                        readOnly={readOnly}
                        disabled={mode === 'edit'}
                        valueExpr={'StatusID'}
                        displayExpr={'StatusName'}
                        label={Config.lang('Trang_thai')}
                        loading={loading.LoadcmbStatus}
                        dataSource={dataCboStatus}
                        error={error?.StatusID}
                        value={String(dataMaster?.StatusID)}
                        onChange={e => onChange('StatusID', e)}
                        renderSelectedItem={(e) => {
                            const { StatusName = '' } = e?.data || {};
                            return <Typography color={dataMaster?.StatusColor}>{StatusName}</Typography>
                        }}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <DatePicker
                        clearAble
                        required
                        label={Config.lang('Hieu_luc_tu')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        max={dataMaster.DateTo}
                        error={error?.DateFrom}
                        value={dataMaster?.DateFrom}
                        onChange={e => onChange('DateFrom', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <DatePicker
                        clearAble
                        label={Config.lang('Hieu_luc_den')}
                        readOnly={readOnly}
                        displayFormat={"DD/MM/YYYY"}
                        min={dataMaster.DateFrom}
                        value={dataMaster?.DateTo}
                        onChange={e => onChange('DateTo', e)}
                    />
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                    <Dropdown
                        clearAble
                        readOnly={readOnly}
                        valueExpr={'UserGroupID'}
                        displayExpr={'UserGroupName'}
                        label={Config.lang('Nhom_nguoi_dung')}
                        loading={loading.LoadGroupUser}
                        dataSource={dataCboUserGroup}
                        error={error?.UserGroupID}
                        value={dataMaster?.UserGroupID}
                        onChange={e => onChange('UserGroupID', e)}
                    />
                </Col>
                <Col xs={12}>{renderGridRight}</Col>
            </Row>
        </W2W>
    )
};

export default connect(null, (dispatch) => ({
    W05F2030Actions: bindActionCreators(W05F2030Actions, dispatch),
}))(W05F2030);


